/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 18/12/2020
 */

import * as SessionUtils from '@/core/session_utils.js'

const procedureAllItemsRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        cart_item_id: 0,
        procedure_index: 0,
        procedure_type: 'cart'
    }
}

export default procedureAllItemsRequest;